import moment from 'moment';

export const REPORT_NETWORK_CENTER_ID = 'all';
export const REPORT_NETWORK_CENTER_LABEL = 'Все клубы сети';

export const REPORT_TAB_KEYS = [
  'summary',
  'money',
  'occupancy',
  'trainers',
  'receivables',
  'popular',
  'comparison',
  'clients',
];

export const REPORT_TAB_LABELS = [
  'Сводка',
  'Деньги',
  'Загрузка',
  'Тренеры',
  'К получению',
  'Популярные дни/время',
  'Сравнение периодов',
  'Клиенты',
];

export const REPORT_PERIOD_PRESETS = [
  { key: 'thisMonth', label: 'Этот месяц' },
  { key: 'lastMonth', label: 'Прошлый месяц' },
  { key: 'days30', label: '30 дней' },
];

export function periodPreset(key, now = moment()) {
  const m = moment(now);
  if (key === 'thisMonth') {
    return {
      from: m.clone().startOf('month').format('YYYY-MM-DD'),
      to: m.clone().format('YYYY-MM-DD'),
    };
  }
  if (key === 'lastMonth') {
    const last = m.clone().subtract(1, 'month');
    return {
      from: last.clone().startOf('month').format('YYYY-MM-DD'),
      to: last.clone().endOf('month').format('YYYY-MM-DD'),
    };
  }
  if (key === 'days30') {
    return {
      from: m.clone().subtract(29, 'days').format('YYYY-MM-DD'),
      to: m.clone().format('YYYY-MM-DD'),
    };
  }
  return null;
}

function isIsoDate(value) {
  return /^\d{4}-\d{2}-\d{2}$/.test(String(value || ''));
}

export function parseReportsQuery(search) {
  const query = new URLSearchParams(search || '');
  const tabKey = query.get('tab');
  const tab = REPORT_TAB_KEYS.indexOf(tabKey);
  const from = query.get('from');
  const to = query.get('to');
  return {
    centerId: query.get('centerId') || '',
    from: isIsoDate(from) ? from : '',
    to: isIsoDate(to) ? to : '',
    tab: tab >= 0 ? tab : 0,
    attendedOnly: query.get('attended') === '1',
  };
}

export function buildReportsPath({ centerId, from, to, tab, attendedOnly }) {
  const params = new URLSearchParams();
  if (centerId) params.set('centerId', String(centerId));
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const key = typeof tab === 'number' ? REPORT_TAB_KEYS[tab] : tab;
  if (key && key !== REPORT_TAB_KEYS[0]) params.set('tab', key);
  if (attendedOnly) params.set('attended', '1');
  const qs = params.toString();
  return `/reports${qs ? `?${qs}` : ''}`;
}
